module.exports = "/_next/static/images/Hero@2x-7469487116f0d80e809e2c07ea770dd6.webp";